import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ServiceTicketStore } from '../../../../../@store';
import { CommonStandaloneModule } from '../../../../common-standalone.module';

@Component({
  selector: 'app-service-ticket-call-support',
  standalone: true,
  imports: [CommonStandaloneModule, MatButtonModule, MatIconModule],
  templateUrl: './service-ticket-call-support.component.html',
  styleUrls: ['./service-ticket-call-support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketCallSupportComponent implements OnInit, OnDestroy {
  boilerSerial: string;

  private ngUnsubscribe$ = new Subject<void>();

  constructor(private serviceTicketStore: ServiceTicketStore) {}

  ngOnInit(): void {
    this.serviceTicketStore.requestRoutingProviderPayloadBoilerSerial$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((requestRoutingProviderPayloadBoilerSerial) => {
        this.boilerSerial = requestRoutingProviderPayloadBoilerSerial;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  openCallPage(): void {
    if (this.boilerSerial) {
      this.serviceTicketStore.requestRoutingProvider(this.boilerSerial);
    }
    this.serviceTicketStore.openCallPage();
  }
}
